import React from 'react';

// import Icon from '@atlaskit/icon';
// import AddIcon from '@atlaskit/icon/glyph/add';
// import BulletListIcon from '@atlaskit/icon/glyph/bullet-list';
// import CalendarIcon from '@atlaskit/icon/glyph/calendar';
// import EditorAlignLeftIcon from '@atlaskit/icon/glyph/editor/align-left';
// import Frequent from '@atlaskit/icon/glyph/emoji/frequent';
// import FileIcon from '@atlaskit/icon/glyph/file';
// import Page from '@atlaskit/icon/glyph/page';

// import { AppsFilterGlyph } from '../../../constants/icons/app-filter';
// import { FolderOpenGlyph } from '../../../constants/icons/folder-open';
// import { LabelGlyph } from '../../../constants/icons/label';
// import { PersonGlyph } from '../../../constants/icons/person';

import AssetsSchemaIcon from '@atlaskit/icon-lab/core/assets-schema';
import JobFamilyIcon from '@atlaskit/icon/core/briefcase';
import CalendarIcon from '@atlaskit/icon/core/calendar';
import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import CustomizeIcon from '@atlaskit/icon/core/customize';
import FileIcon from '@atlaskit/icon/core/files';
import FocusAreaIcon from '@atlaskit/icon/core/focus-area';
import FolderClosedIcon from '@atlaskit/icon/core/folder-closed';
import BulletedListIcon from '@atlaskit/icon/core/list-bulleted';
import PersonIcon from '@atlaskit/icon/core/person';
import PersonAddedIcon from '@atlaskit/icon/core/person-added';
import ProjectIcon from '@atlaskit/icon/core/project';
import SortDescendingIcon from '@atlaskit/icon/core/sort-descending';
import StatusVerifiedIcon from '@atlaskit/icon/core/status-verified';
import TagIcon from '@atlaskit/icon/core/tag';
import TeamsIcon from '@atlaskit/icon/core/teams';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import { B400, N500 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import { type FilterOrControlId } from '../../../constants/filters/types';

export const getIcon = ({
	filterOrControlId,
	isSelected,
	label = '',
}: {
	filterOrControlId: FilterOrControlId;
	isSelected: boolean;
	label?: string;
}): React.JSX.Element | null | undefined => {
	switch (filterOrControlId) {
		case 'owner':
		case 'assignee':
		case 'contributor':
		case 'createdBy':
			return (
				<PersonIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected', B400) : token('color.icon', N500)}
				/>
			);
		case 'verified':
			return (
				<StatusVerifiedIcon
					LEGACY_size="small"
					label={label}
					color={isSelected ? token('color.icon.selected', B400) : token('color.icon', N500)}
				/>
			);
		case 'label':
			return (
				<TagIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected', B400) : token('color.icon', N500)}
				/>
			);
		case 'content':
			return (
				<BulletedListIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected', B400) : token('color.icon', N500)}
				/>
			);
		case 'focusAreaType':
		case 'focusAreaUnder':
			return (
				<FocusAreaIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected', B400) : token('color.icon', N500)}
				/>
			);
		case 'lastUpdated':
			return (
				<CalendarIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected', B400) : token('color.icon', N500)}
				/>
			);
		case 'project':
			return (
				<ProjectIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected', B400) : token('color.icon', N500)}
				/>
			);
		case 'space':
			return (
				<FolderClosedIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected', B400) : token('color.icon', N500)}
				/>
			);
		case 'onlyTitleMatch':
			return null; // Title match doesn't show an icon, only a checkbox
		case 'pageStatus':
			return (
				<CheckCircleIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected', B400) : token('color.icon', N500)}
				/>
			);
		case 'lastUpdatedBy':
			return (
				<PersonIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected', B400) : token('color.icon', N500)}
				/>
			);
		case 'universalTypeFilter':
			return (
				<FileIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected', B400) : token('color.icon', N500)}
				/>
			);
		case 'dropdown':
			return (
				<CustomizeIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected', B400) : token('color.icon', N500)}
				/>
			);
		case 'sort':
			return (
				<SortDescendingIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected', B400) : token('color.icon', N500)}
				/>
			);
		case 'assetsSchema':
			return (
				<AssetsSchemaIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected', B400) : token('color.icon', N500)}
				/>
			);
		case 'positionTeam':
			return (
				<TeamsIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected', B400) : token('color.icon', N500)}
				/>
			);
		case 'positionEmploymentType':
		case 'positionStatus':
			return (
				<PersonAddedIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected', B400) : token('color.icon', N500)}
				/>
			);
		case 'positionJobFamily':
			return (
				<JobFamilyIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected', B400) : token('color.icon', N500)}
				/>
			);
	}
};

export const FilterButtonIconContainer = ({
	children,
}: React.PropsWithChildren<{}>): React.JSX.Element => {
	return <Box xcss={filterButtonIconContainerStyles}>{children}</Box>;
};

const filterButtonIconContainerStyles = xcss({
	display: 'flex',
	alignItems: 'center',
	gap: 'space.075',
});
